<template>
  <div style="height: 100%; background: #F2F2F6">
      <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item >密码修改</el-breadcrumb-item>
        </el-breadcrumb>
    <el-row style="padding-top: 30px">
      <el-col :span="12" >
        <el-form
          :model="customer"
          :rules="rules"
          size="mini"
          ref="customerForm"
          label-width="150px"
          label-position="right"
        >
         <el-form-item label="原密码" prop="password">
            <el-input
              v-model="customer.password"
              show-password
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="newpassword">
            <el-input
              v-model="customer.newpassword"
              show-password
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="newpassword2">
            <el-input
              v-model="customer.newpassword2"
              autocomplete="off"
              show-password
            ></el-input>
          </el-form-item>
          <el-divider></el-divider>
          <el-form-item>
            <el-button type="primary" @click="Password()">保存</el-button>
            <el-button @click="back()">取消</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Vue from "vue";
import { hex_md5 } from "../../assets/js/md5";
export default {
  name: "Password",
  data() {
    var passwordCheck = (tule, value, callback) => {
      if (value.length < 6) {
        callback(new Error("密码不能小于6位"));
      } else {
        callback();
      }
    };
    var password2Check = (tule, value, callback) => {
      if (value.length < 6) {
        callback(new Error("密码不能小于6位"));
      } else if (value !== this.customer.newpassword) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };

    return {
      customer: {
        password:'',
        newpassword: "",
        newpassword2: "",
      },
      rules: {password: [
          { required: true, message: "请输入原密码", trigger: "blur" },
          { validator: passwordCheck, trigger: "blur" },
        ],newpassword: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          { validator: passwordCheck, trigger: "blur" },
        ],
        newpassword2: [
          { required: true, message: "请输入确认密码", trigger: "blur" },
          { validator: password2Check, trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    Password() {
      this.$refs.customerForm.validate((valid) => {
        if (valid) {
          Vue.axios
          .post("/factory/user/password/edit", {
            password: hex_md5(this.customer.password),
            newpassword: hex_md5(this.customer.newpassword),
          }).then((res)=>{
            if(res.data.errcode==0){
              this.$message({
                showClose: true,
                message: "密码修改成功",
                type: "success",
              });
            }else{
              this.$message({
              showClose: true,
              message: res.data.errmsg || "发生未知错误，请联系相关人员查看",
              type: "error",
            });
            }
          })

         
        } else {
            return false
        }
      });
    },
    back() {
      this.$router.back();
    },
  },
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.el-popover {
  text-align: center;
  padding: 3px;
}

/* .el-transfer{
  width:100%
} */

.el-transfer-panel .el-transfer-panel__header .el-checkbox .el-checkbox__label {
  font-size: 12px;
}

/* .el-transfer-panel{
  width:40%;
} */

.el-transfer__buttons {
  flex-direction: column;
  width: 40px;
  padding: 0 10px;
}

.el-transfer__button {
  margin: 5px 0 !important;
  padding: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/User/Password.vue